module.exports = __webpack_public_path__ + "static/media/29EUNOG11.904b46bc.jpg";